import React, { CSSProperties } from "react"
import { MobergButton } from "../MobergButton/MobergButton"
import { MobergIconSize } from "../MobergIcon/MobergIcon"
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md"
import { MobergMenuController } from "../../Hooks/useMobergMenu"
import { MobergFontFamily } from "../MobergFont/MobergFont"

type MobergMenuDropdownButtonProps = {
   menu: MobergMenuController
   style: CSSProperties
}

export const MobergMenuDropdownButton: React.FC<MobergMenuDropdownButtonProps> = ({ menu, children, style }) => {
    return (
        <MobergButton onClick={menu.open} style={{ 
            justifyContent: "space-between", 
            border: "1px solid var(--color-border-default)", 
            fontWeight: "normal", 
            fontFamily: MobergFontFamily.REGULAR, 
            paddingRight: "8px", 
            ...style 
        }}>
            {children}
            <span style={{ pointerEvents: "none" }}>
                {menu.isOpen 
                    ? <MdKeyboardArrowUp size={MobergIconSize.REGULAR} /> 
                    : <MdKeyboardArrowDown size={MobergIconSize.REGULAR} />
                }
            </span>
        </MobergButton>
    )
}
